module.exports = __webpack_public_path__ + "static/media/trumpet.c5be7959.svg";